<template>
  <div class="light-up-container">
    <headerWX class="headerWX"></headerWX>
    <div class="container">
      <!-- <img
        class="light-up-bg"
        src="@/assets/imgs/LightUp/bg.png"
        alt="Light Up"
      /> -->
      <!-- 具体内容 -->
      <div class="Content">
        <!-- 标头 -->
        <div class="tit">
          <img src="@/assets/imgs/LightUp/tit.png" alt="" />
        </div>

        <!-- 总剩余次数 -->
        <div class="remaining-times">
          <div class="remaining-badge">总剩余白金币: {{ userMoney }}</div>
        </div>

        <!-- 点亮网格 -->
        <div class="grid-container">
          <div class="grid">
            <div
              v-for="(item, index) in gridItems"
              :key="index"
              :class="['grid-item', item.status]"
              :style="getGridStyle(index)"
            >
            </div>
          </div>

          <!-- 右侧空白方块 -->
          <div class="right-blanks">
            <div
              v-for="(blank, index) in rightBlanks"
              :key="index"
              class="blank-item"
            >
              <el-tooltip
                class="item"
                effect="dark"
                :content="blank.itemName"
                placement="top"
              >
                <div
                  @click="claimLineReward(blank)"
                  :class="[
                    'blank-item-bg',
                    blank.status == 1 ? 'blank-item-bg-Reward' : '',
                  ]"
                >
                  <img
                    :src="blank.itemImg"
                  />
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>

        <!-- 底部空白方块 -->
        <div class="bottom-blanks">
          <div
            v-for="(blank, index) in bottomBlanks"
            :key="index"
            class="blank-item"
          >
            <el-tooltip
              class="item"
              effect="dark"
              :content="blank.itemName"
              placement="top"
            >
              <div
                :class="[
                  'blank-item-bg',
                  blank.status == 1 ? 'blank-item-bg-Reward' : '',
                ]"
                @click="claimLineReward(blank)"
              >
                <img
                  :src="blank.itemImg"
                  alt=""
                />
              </div>
            </el-tooltip>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="action-buttons" v-if="freeFiveUsed == false">
          <div>
            <img
              @click="lightUpFive('mian')"
              src="@/assets/imgs/LightUp/freeFive.png"
              alt="免费点亮五次"
            />
          </div>
        </div>
        <div class="action-buttons" v-else>
          <div class="action-button">
            <img
              @click="lightUpOnce"
              src="@/assets/imgs/LightUp/one.png"
              :style="{
                filter:
                  grandPrizeActivated == true ? 'grayscale(100%)' : 'none',
              }"
              alt="点亮一次"
            />
            <p v-if="grandPrizeActivated == false">
              本次消耗{{ noeMoney }}白金币
            </p>
          </div>
          <div class="action-button">
            <img
              @click="lightUpFive('fu')"
              src="@/assets/imgs/LightUp/Five.png"
              :style="{
                filter:
                  grandPrizeActivated == true || lightCount > 20
                    ? 'grayscale(100%)'
                    : 'none',
              }"
              alt="点亮五次"
            />
            <p v-if="!(lightCount > 20)">
              本次消耗{{ fiveMoney }}白金币
            </p>
          </div>
        </div>

        <!-- 领取大奖按钮 -->
        <div class="Winning-grand-prize">
          <img
            :style="{
              filter:
                grandPrizeActivated == false || grandPrizeClaimed == true
                  ? 'grayscale(100%)'
                  : 'none',
            }"
            @click="getGrandPrize()"
            src="@/assets/imgs/LightUp/Winning-grand-prize.png"
            alt=""
          />
        </div>

        <!-- 大图预览 -->
        <div class="Large-image-preview">
          <div class="Large-image-preview-tit">
            <img src="@/assets/imgs/LightUp/Preview-tit.png" alt="大奖预览图" />
          </div>
          <div class="grandPrize">
            <img src="@/assets/imgs/LightUp/grandPrize.gif" alt="" />
          </div>
          <div class="Large-image-preview-text">
            【预览图仅供参考，实际效果以游戏内为准】
          </div>
        </div>

        <!-- 活动说明 -->
        <div class="Activity-Description">
          <div class="Activity-Description-tit">
            <img
              src="@/assets/imgs/LightUp/Activity-Description-tit.png"
              alt="大奖预览图"
            />
          </div>
          <p class="Activity-Description-date">
            本次活动时间：2026年4月8日—2026年5月8日24点
          </p>
          <div class="Activity-Description-container">
            <p>
              1.活动期间内，玩家通过点亮灯牌即可获得对应道具奖励，每次点灯将随机点亮且必定会点亮还未被点亮的灯牌！每位玩家首次五连点亮为免费！并且每次点亮将获得泡点*26666，当全部灯牌都被点亮后即可解锁大奖！
            </p>
            <p>本期大奖为：限定动态戒指— 
              <span
                style="color: red; font-size: 20px; font-weight: 700"
                >闪耀钻戒</span>
            </p>
            <p>
              2.当点亮<span
                style="color: red; font-size: 20px; font-weight: 700"
                >同一行/同一列/同一对角线</span
              >时，即可获得对应的道具奖励。奖励在领取后将直接发送到游戏中。
            </p>
            <p>3.点亮灯牌的费用如下：</p>
            <p style="text-indent: 2em">
              第1~第5次免费（免费五连点亮，每个账号仅限一次）
            </p>
            <p style="text-indent: 2em">第6~第10次40白金币/次</p>
            <p style="text-indent: 2em">第11~第15次80白金币/次</p>
            <p style="text-indent: 2em">第16~第20次120白金币/次</p>
            <p style="text-indent: 2em">第21~第25次160白金币/次</p>
            <p>5.当剩余未点亮的灯牌数量小于5个时，无法使用点亮五次功能。</p>
          </div>
        </div>
      </div>
    </div>

    <footerWX class="footerWX"></footerWX>
  </div>
</template>

<script>
import headerWX from "@/components/Header";
import footerWX from "@/components/Footer";
import axios from "axios";
import Cookies from "js-cookie";
export default {
  name: "LightUp",
  components: {
    headerWX,
    footerWX,
  },
  data() {
    return {
      // 网格配置
      gridItems: Array.from({ length: 25 }, (_, index) => ({
        status: "unlit",
        index: index,
      })), // 5x5网格

      rightBlanks: [], // 右侧6个空白方块
      bottomBlanks: [], // 底部6个空白方块
      freeFiveUsed: false, // 是否首次免费 false是  true否
      userMoney: 0, //用户余额
      noeMoney: 0, //单抽需要的金额
      fiveMoney: 0, //五抽需要的金额
      lightCount: 0, // 抽取次数
      grandPrizeActivated: false, //大奖是否解锁
      grandPrizeClaimed: false, //大奖是否领取

      isLottery: false, // 是否正在抽奖
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    // 拼图切片背景计算
    getGridStyle(index) {
      const row = Math.floor(index / 5);
      const col = index % 5;
      const posX = col * 25;
      const posY = row * 25;

      return {
        backgroundImage: `url(${require('@/assets/imgs/LightUp/acBg.png')})`,
        backgroundSize: "500% 500%",
        backgroundPosition: `${posX}% ${posY}%`,
        backgroundRepeat: "no-repeat",
      };
    },

    // 点亮一次
    async lightUpOnce() {
      if (this.isLottery == true) {
        return this.$message.info("正在抽奖，请稍后重试！");
      }
      if (this.grandPrizeActivated == true) {
        return;
      }
      if (this.userMoney < this.noeMoney) {
        this.$message.info("白金币不足，请先去获取把！");
        return;
      }
      this.isLottery = true;
      await axios({
        method: "post",
        url: "/eventactivity/lightOnce",
        headers: {
          token: Cookies.get("wx_token"),
        },
        data: {
          userId: Cookies.get("wx_userId"), // userId
          platForm: "web",
        },
      }).then(async ({ data }) => {
        if (data.state == 200) {
          // 每次执行前检查是否还有未点亮的方块
          const unlitCount = this.gridItems.filter(
            (item) => item.status === "unlit",
          ).length;

          if (unlitCount === 0) {
            return;
          }

          // 使用 Promise 封装，等待单次动画完成
          await new Promise((resolve) => {
            this.lightUpOnceWithCallback(resolve, data.data.lightedGrids, 0);
          });

          setTimeout(() => {
            console.log("停止重新请求");
            this.isLottery = false;
            this.init();
          }, 1000);
        } else {
          this.$message.error(data.message);
        }
      });
    },

    // 随机闪烁效果
    randomFlash(availableIndices, list, index, callback) {
      const flashCount = 5; // 闪烁次数
      let currentFlash = 0;
      let flashInterval;
      let currentIndex = -1;

      // 开始闪烁
      flashInterval = setInterval(() => {
        // 随机选择一个可用索引
        const randomIndex =
          availableIndices[Math.floor(Math.random() * availableIndices.length)];

        // 恢复上一个闪烁的方块
        if (currentIndex !== -1 && currentIndex !== randomIndex) {
          this.$set(this.gridItems, currentIndex, { status: "unlit" });
        }

        // 临时设置为 lit 状态（闪烁效果）
        this.$set(this.gridItems, randomIndex, { status: "lit" });
        currentIndex = randomIndex;

        currentFlash++;

        // 闪烁结束
        if (currentFlash >= flashCount) {
          clearInterval(flashInterval);
          // 最终选择一个索引
          const finalIndex = list[index];
          // 确保最终索引的状态正确
          if (currentIndex !== finalIndex) {
            this.$set(this.gridItems, currentIndex, { status: "unlit" });
          }
          callback(finalIndex);
        }
      }, 300);
    },

    // 点亮五次
    async lightUpFive(type) {
      if (this.isLottery == true) {
        return this.$message.info("正在抽奖，请稍后重试！");
      }
      if (this.grandPrizeActivated == true) {
        return;
      }
      if (Number(this.lightCount) > 20) {
        return;
      }
      if (type == "mian") {
      } else {
        if (this.userMoney < this.noeMoney) {
          this.$message.info("白金币不足，请先去获取把！");
          return;
        }
      }
      this.isLottery = true;
      await axios({
        method: "post",
        url: "/eventactivity/lightFive",
        headers: {
          token: Cookies.get("wx_token"),
        },
        data: {
          userId: Cookies.get("wx_userId"), // userId
          platForm: "web",
        },
      }).then(async ({ data }) => {
        if (data.state == 200) {
          const list = data.data.lightedGrids;
          for (let i = 0; i < list.length; i++) {
            // 每次执行前检查是否还有未点亮的方块
            const unlitCount = this.gridItems.filter(
              (item) => item.status === "unlit",
            ).length;

            if (unlitCount === 0) break;

            // 使用 Promise 封装，等待单次动画完成
            await new Promise((resolve) => {
              this.lightUpOnceWithCallback(resolve, list, i);
            });
          }
          setTimeout(() => {
            console.log("停止重新请求");

            this.isLottery = false;
            this.init();
          }, 1000);
        } else {
          this.$message.error(data.message);
        }
      });
    },

    // 修改 lightUpOnce，让它支持回调，以便知道什么时候动画结束
    lightUpOnceWithCallback(done, list, i) {
      const unlitIndices = this.gridItems
        .map((item, index) => (item.status === "unlit" ? index : -1))
        .filter((index) => index !== -1);

      if (unlitIndices.length > 0) {
        this.randomFlash(unlitIndices, list, i, (finalIndex) => {
          this.$set(this.gridItems, finalIndex - 1, { status: "disabled" });
          if (done) done(); // 动画结束，通知 Promise 继续下一次循环
        });
      } else {
        if (done) done();
      }
    },

    //领取线路奖励
    async claimLineReward(item) {
      if (item.status == 0) {
        return this.$message.info("当前奖励未激活哦！");
      } else if (item.status == 2) {
        return this.$message.info("当前奖励已领取！");
      } else if (item.status == 1) {
        await axios({
          method: "post",
          url: "/eventactivity/claimLineReward",
          headers: {
            token: Cookies.get("wx_token"),
          },
          data: {
            userId: Cookies.get("wx_userId"), // userId
            platForm: "web",
            lineCode: item.lineCode,
          },
        }).then(({ data }) => {
          if (data.state == 200) {
            this.$message.success("领取成功");
            this.init();
          } else {
            this.$message.error(data.message);
          }
        });
      }
    },
    //领取大奖
    async getGrandPrize() {
      if (this.grandPrizeActivated == false || this.grandPrizeClaimed == true) {
        return;
      }
      console.log("lingqu");
      await axios({
        method: "post",
        url: "/eventactivity/claimGrandPrize",
        headers: {
          token: Cookies.get("wx_token"),
        },
        data: {
          userId: Cookies.get("wx_userId"), // userId
          platForm: "web",
        },
      }).then(({ data }) => {
        if (data.state == 200) {
          this.$message.success("领取成功");
          this.init();
        } else {
          this.$message.error(data.message);
        }
      });
    },

    //初始化
    async init() {
      await axios({
        method: "post",
        url: "/eventactivity/getLanternStatus",
        headers: {
          token: Cookies.get("wx_token"),
        },
        data: {
          userId: Cookies.get("wx_userId"), // userId
          platForm: "web",
        },
      })
        .then((res) => {
          if (res.data.state == 200) {
            // 筛选出有效的lineCode
            let colList = res.data.data.lineRewards.filter((item) => {
              const validLineCodes = [
                "col_1",
                "col_2",
                "col_3",
                "col_4",
                "col_5",
                "diag_1",
              ];
              return validLineCodes.includes(item.lineCode);
            });

            let rowList = res.data.data.lineRewards.filter((item) => {
              const validLineCodes = [
                "row_1",
                "row_2",
                "row_3",
                "row_4",
                "row_5",
                "diag_2",
              ];
              return validLineCodes.includes(item.lineCode);
            });
            // 查找diag_1元素并移到第一个位置
            const diag1Index = rowList.findIndex(
              (item) => item.lineCode === "diag_2",
            );
            if (diag1Index > -1) {
              const diag1Item = rowList.splice(diag1Index, 1)[0];
              rowList.unshift(diag1Item);
            }

            this.rightBlanks = rowList;
            this.bottomBlanks = colList;
            this.freeFiveUsed = res.data.data.freeFiveUsed;
            this.userMoney = res.data.data.userMoney;
            this.noeMoney = res.data.data.currentPrice;
            this.fiveMoney = res.data.data.nextFivePrice;
            //抽取次数
            this.lightCount = res.data.data.lightCount;
            //
            this.grandPrizeActivated = res.data.data.grandPrizeActivated;
            //是否领取
            this.grandPrizeClaimed = res.data.data.grandPrizeClaimed;
            //修改gridItems
            // 让索引为 [20, 23, 4, 22, 21] 的元素状态变成 disabled
            const disabledIndices = res.data.data.lightedGrids;
            disabledIndices.forEach((index) => {
              this.$set(this.gridItems, index - 1, {
                ...this.gridItems[index - 1],
                status: "disabled",
              });
            });
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
  },
};
</script>
<style scoped lang="less">
.light-up-container {
  width: 100%;
  .headerWX {
    width: 100%;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
  }

  .container {
    margin: 0 auto;
    max-width: 2000px;
    min-width: 1200px;
    width: 100%;
    position: relative;
    background-image: url("../../assets/imgs/LightUp/bg.png");
    background-size: 100%;

    .Content {
      margin: auto;
      padding-top: 125px;
      width: 80%;
      min-height: 600px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .tit {
        width: 100%;
        text-align: center;
        margin-bottom: 20px;

        img {
          max-width: 80%;
          height: auto;
        }
      }

      .remaining-times {
        margin-bottom: -85px;

        .remaining-badge {
          background-color: #ff4d4f;
          color: white;
          padding: 8px 16px;
          border-radius: 20px;
          font-size: 16px;
          font-weight: bold;
          box-shadow: 0 2px 8px rgba(255, 77, 79, 0.4);
        }
      }

      .grid-container {
        display: flex;
        align-items: flex-end;
        margin-bottom: 30px;

        .grid {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          grid-template-rows: repeat(5, 1fr);
          gap: 18px;
          margin-right: 20px;
          // border: 4px solid #f2e3c4;

          .grid-item {
            width: 140px;
            height: 140px;
            transition: filter 0.4s ease;
            position: relative;

            &.unlit {
              filter: grayscale(100%) brightness(0.5);
            }

            &.lit {
              filter: grayscale(0%) brightness(1.5);
              z-index: 2;
              box-shadow: 0 0 15px #fff;
            }

            &.disabled {
              filter: grayscale(0%) brightness(1);
            }
          }
        }

        .right-blanks {
          display: flex;
          flex-direction: column;
          gap: 10px;
          width: 150px;
          .blank-item {
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }

      .bottom-blanks {
        display: flex;
        gap: 10px;
        margin-bottom: 40px;

        .blank-item:last-child {
          padding-left: 10px;
        }
      }
      .blank-item {
        width: 150px;
        height: 150px;
        .blank-item-bg {
          width: 100px;
          height: 100px;
          background: rgba(255, 255, 255, 0.5);
          box-shadow: 0px 2px 4px 0px #ffe4b8;
          border-radius: 10px 10px 10px 10px;
          border: 1px solid #ffffff;
          margin: auto;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          > img {
            max-width: 100%;
            max-height: 100%;
          }
          .no1 {
            filter: grayscale(100%);
          }
        }
        .blank-item-bg-Reward {
          cursor: pointer;

          &::before {
            content: "";
            position: absolute;
            top: -14px;
            left: -14px;
            right: -14px;
            bottom: -14px;
            border-radius: 8px;
            background: #df3b09;
            animation: pulse 1.5s ease-out infinite;
          }

          @keyframes pulse {
            0% {
              transform: scale(0.95);
              opacity: 0.6;
            }
            70% {
              transform: scale(1.05);
              opacity: 0;
            }
            100% {
              transform: scale(0.95);
              opacity: 0;
            }
          }
        }
      }

      .action-buttons {
        display: flex;
        gap: 30px;

        .action-button {
          padding: 12px 30px;
          border: none;
          border-radius: 25px;
          font-size: 18px;
          font-weight: bold;
          color: white;
          cursor: pointer;
          transition: all 0.3s ease;
          text-align: center;
          p {
            margin-top: 20px;
            font-size: 20px;
            font-weight: 800;
            text-shadow: 1px 1px 0 #f26d2e, -1px -1px 0 #f26d2e,
              1px -1px 0 #f26d2e, -1px 1px 0 #f26d2e;
          }

          &:hover:not(:disabled) {
            transform: translateY(-2px);
          }
        }
      }

      .Winning-grand-prize {
        margin: 20px 0;
        cursor: pointer;
      }

      .Large-image-preview {
        border-radius: 20px;
        border: 4px solid #f0cccc85;
        background: #fff;
        width: 80%;
        padding-bottom: 50px;
        .Large-image-preview-tit {
          padding: 20px 0;
          width: 100%;
          text-align: center;
        }
        .grandPrize {
          width: 100%;
          text-align: center;
          > img {
            max-width: 80%;
          }
        }
        .Large-image-preview-text{
          width: 100%;
          text-align: center;
          font-size: 20px;
          font-weight: 700;
        }
      }
      .Activity-Description {
        margin: 50px 0;
        border-radius: 20px;
        border: 4px solid #f0cccc85;
        background: #fff;
        width: 80%;
        .Activity-Description-tit {
          padding: 20px 0 10px;
          width: 100%;
          text-align: center;
        }
        .Activity-Description-date {
          width: 100%;
          text-align: center;
          font-size: 20px;
          color: red;
          padding-bottom: 10px;
        }
        .Activity-Description-container {
          width: 95%;
          margin: auto;
          > p {
            font-size: 18px;
            margin-bottom: 10px;
            text-indent: 1em;
            line-height: 25px;
          }
        }
      }
    }
  }

  .footerWX {
  }
}
</style>